<template>
  <van-panel class="panel round-md overflow">
    <div
      slot="header"
      class="van-cell van-panel__header"
    >
      <van-icon
        name="user-o"
        class="van-cell__left-icon"
      />
      <div
        class="van-cell__title"
        v-if="list.vipBpmForMyAppDtoList[0]"
      >
        <span class="font-bold">
          {{ $t('K222','送审人') }}：
          {{ list.vipBpmForMyAppDtoList[0].sentEmpNo }}
        </span>
        <div class="van-cell__label">
          {{ `送审时间：${list.vipBpmForMyAppDtoList[0].sentTime}` }}
          <span v-if="list.vipBpmForMyAppDtoList[0].approveState == 1">
            {{ $t('F102','审批中') }}
          </span>
          <span
            class="main-color"
            v-else-if="list.vipBpmForMyAppDtoList[0].approveState == 2"
          >
            {{ $t('F112','审批通过') }}
          </span>
          <span
            class="red"
            v-else-if="list.vipBpmForMyAppDtoList[0].approveState == 3"
          >
            {{ $t('F113','审批拒绝') }}
          </span>
          <span v-else>
            {{ $t('B008','取消') }}
          </span>
          <br>
          <span v-if="list.vipBpmForMyAppDtoList[0].sentRemark">
            {{ `备注：${list.vipBpmForMyAppDtoList[0].sentRemark}` }}
          </span>
        </div>
      </div>
      <div
        @click="shouTripDesc(list.vipBpmForMyAppDtoList)"
        class="van-cell__value van-panel__header-value"
      >
        <span class="black">
          行程描述
          <van-icon
            name="warning-o"
            class="vertical-middle main-color"
          />
        </span>
      </div>
    </div>
    <!-- 订单 -->
    <van-row
      v-for="item in list.vipBpmForMyAppDtoList"
      :key="item.orderId"
      @click="list.vipBpmForMyAppDtoList.length != 1 ?
        $emit('to-order-detail', item.orderId, item.workItemId, item.orderType) :
        $emit('to-approval-detail', item.orderId, item.workItemId, item.orderType)"
    >
      <!-- 产品类型图片 -->
      <van-col
        class="approvalImg"
        span="5"
      >
        <ld-icon
          class="vertical-bottom linear-main2 round-sm white"
          size="56"
          :type="item.orderType | apprpvalIcon"
        />
      </van-col>

      <!-- 出发到达城市 / 酒店名称 -->
      <van-col span="14">
        <div class="font14 font-bold">
          <span v-if="item.arriveCity">
            {{ item.departCity }} - {{ item.arriveCity }}
          </span>
          <span v-if="item.orderType == 11023">
            {{ item.qzName }}
          </span>
          <span v-else>
            {{ item.departCity }}
            <span class="state gray">{{ item.orderStatusRemark }}</span>
            <span v-if="item.orderType == 11099">{{ item.ccsy }}</span>
          </span>
        </div>

        <!-- 改签 -->
        <div
          class="gray"
          v-if="item.oldDepartDate"
        >
          <span v-show="item.orderType==11003">原航班：</span>
          <span v-show="item.orderType==11011">原车次：</span> {{ item.oldDepartDate | DateYueOrRi }}
        </div>
        <div
          class="gray"
          v-if="item.orderType==11003 || item.orderType==11011"
        >
          <span v-show="item.orderType==11003 || item.orderType==11011">改签后：</span> {{ item.departDate | DateYueOrRi }}
        </div>
        <div
          class="gray"
          v-else
        >
          {{ item.departDate | DateYueOrRi }}
          <span
            class=""
            v-show="item.flightNo"
          >| ({{ item.flightNo }})</span>
          <span v-if="item.orderType == 11099">{{ $t('H041','至') }} {{ item.endDate | DateYueOrRi }}</span>
        </div>
        <!-- 行程人 -->
        <div class="gray">
          {{ item.person }}
        </div>
      </van-col>

      <van-col
        class="red"
        span="5"
      >
        &yen;{{ item.price }}
      </van-col>
    </van-row>

    <slot
      name="footer"
      slot="footer"
    />
  </van-panel>
</template>

<script>
import { Panel } from 'vant'
import Bussiness from 'Utils/business'
import orderMixin from '../allorder/components/orderMixin'

export default {
  components: {
    [Panel.name]: Panel
  },
  mixins: [orderMixin],
  props: {
    list: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    //去审批详情页面
    goApprovalingDetail (id, workItemId, orderType) {
      console.log('id, workItemId, orderType: ', id, workItemId, orderType)
      this.$router.push({ path: '/approval/Detail', query: {
        id, workItemId, orderType
      }})
    },
    //去订单详情
    toOrderDetail (id, workItemId, orderType) {
      Bussiness.toOrderDetail({
        id, workItemId
      }, orderType)
      console.log('id, workItemId, orderType: ', id, workItemId, orderType)
    },
    // 展示行程描述
    shouTripDesc (list) {
      function transfer(item) {
        let contentMap = {
          [$dict.ORDER_TYPE.tk.normal]:'机票 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 票价为' + item.price + '元。',
          [$dict.ORDER_TYPE.tk.change]:'机票改签单 ：' + item.person + ' 由' + item.oldDepartDate + ' ' + item.ydepartNime + ' ' + item.yvoyageZh + ' 改签为 ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 改签费用' + item.price + '元。',
          [$dict.ORDER_TYPE.tk.refund]:'机票退票单 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 退票费为' + item.price + '元。',

          [$dict.ORDER_TYPE.tkIntel.normal]:'国际机票 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 票价为' + item.price + '元。',
          [$dict.ORDER_TYPE.tkIntel.change]:'国际机票改签单 ：' + item.person + ' 由' + item.oldDepartDate + ' ' + item.ydepartNime + ' ' + item.yvoyageZh + ' 改签为 ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 改签费用' + item.price + '元。',
          [$dict.ORDER_TYPE.tkIntel.refund]:'国际机票退票单 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 退票费为' + item.price + '元。',

          [$dict.ORDER_TYPE.tr.normal]:'火车 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 票价为' + item.price + '元。',
          [$dict.ORDER_TYPE.tr.change]:'火车改签单 ：' + item.person + ' 由' + item.oldDepartDate + ' ' + item.ydepartNime + ' ' + item.yvoyageZh + ' 改签为 ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 改签费用' + item.price + '元。',
          [$dict.ORDER_TYPE.tr.refund]:'火车退票单 ：' + item.person + ' ' + item.departDate + ' ' + item.departTime + ' ' + item.departCity + '-' + item.arriveCity + ' 退票费为' + item.price + '元。',

          [$dict.ORDER_TYPE.hotel.normal]:'酒店 ：' + item.person + ' ' + item.departDate + ' ' + ' 入住' + item.flightNo + ' ' + 1 + '晚 房费合计' +  item.price + '元。',
          [$dict.ORDER_TYPE.hotel.refund]:'酒店退票单 ：' + item.person + ' ' + item.departDate + ' ' + ' 入住' + item.flightNo + '  退房 应退金额' +  item.price + '元。',
          [$dict.ORDER_TYPE.visa]:'签证 ：' + item.person + ' ' + item.departDate + ' ' + item.qzName + ' ' + item.price + '元。',
          [$dict.ORDER_TYPE.vipCcsqd]:'出差单：' + item.departDate  + ' - ' + item.endDate + '，到' + item.departCity  + '出差， ' +   item.ccsy ,
        }

        return contentMap[item.orderType]
      }

      let content = ''
      list.forEach(function(item) {
        content += transfer(item)
      })
      content = content.replace(/。/g,'\n\n')
      content = content.replace(/undefined/g,'')
      this.$dialog.alert({
        title: '行程',
        message: content,
        messageAlign:'left',
        confirmButtonText: '知道了'
      })
    },
  },
  filters: {
    DateYueOrRi: function(val) {
      let gao, hao
      gao = val.substr(5, val.length - 5).split('-')
      hao = gao[0] + '月' + gao[1] + '日'
      return hao
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  margin-top: 5px;
  background-color: @color-background-white;

  .van-cell__title, .van-panel__header-value {
    flex: auto;
  }

  .van-panel__content {
    padding: 5px 0 0 40px;
    .state{
      padding-left: 20px;
    }
    .approvalImg {
      position: relative;
      img {
        width: 56px;
      }
      .label {
        position: absolute;
        top: 2px;
        left: 5px;
        color: #fff;
      }
    }

    > .van-row {
      margin-bottom: 12px;
    }
  }

  .van-panel__footer {
    box-shadow: 0px 2px 35px 0px
      rgba(0, 0, 0, 0.02);

    .agreeBtn {
      margin-left: 10px;
    }
  }
}

</style>
